import { environmentStg } from '@ups/xplat/environments';
import { deepMerge } from '@ups/xplat/utils';

export const environment = deepMerge(environmentStg, {
  name: process.env['Localize:AppName@ionic-enterprise-appstore'],
  auth0: {
    clientId: process.env['Auth0:ClientId@ionic-enterprise-appstore'],
    useRefreshTokens: true,
  },
  security: {
    appId: process.env['Security:AppId@ionic-enterprise-appstore'],
  },
  offline: {
    enabled: false,
  },
});
